export default __webpack_public_path__ + "static/media/more-yellow.43e9f447.svg";